import { render, staticRenderFns } from "./couponCate.vue?vue&type=template&id=460c2e50&scoped=true&"
import script from "./couponCate.vue?vue&type=script&lang=js&"
export * from "./couponCate.vue?vue&type=script&lang=js&"
import style0 from "./couponCate.vue?vue&type=style&index=0&id=460c2e50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460c2e50",
  null
  
)

export default component.exports